export default class QuoteResultAnalyzer {
    private quoteResult: any;

    private analysis: any = {};

    constructor(_quote: any) {
        this.quoteResult = _quote;
    }

    public analyze() {
        this.analysis.total = this.quoteResult.quote_amount;
        if (!Array.isArray(this.quoteResult.quote_lines)) {
            this.quoteResult.quote_lines = Object.keys(this.quoteResult.quote_lines).map(
                i => this.quoteResult.quote_lines[i]
            );
        }
        for (const { items, index } of this.quoteResult.quote_lines.map(
            (items: any, index: any) => ({ items, index })
        )) {
            for (const item of items) {
                if (
                    item.tms_quote_lines_type == 'CHARGE-BASE' ||
                    item.tms_quote_lines_type == 'CHARGE-MIN'
                ) {
                    // base charge
                    this.analysis['baseCharge'] = item;
                } else if (item.tms_quote_lines_type == 'CHARGE-ACC') {
                    // accessorial charge
                    switch (item.tms_quote_lines_lane_text) {
                        case 'ROC':
                            this.analysis[`ROC`] = item;
                            break;
                        case 'WG':
                            this.analysis[`WG`] = item;
                            break;
                    }
                }
            }
        }
    }

    public mapEstimate(input: any) {
        // map estimate quote amount with result
        let result = this.analysis;
        input.total = result.total || 0;
        input.palletSpaceCharge =
            result.baseCharge && result.baseCharge.tms_quote_lines_quote_amount;
        input.palletSpaceChargeText =
            result.baseCharge && result.baseCharge.tms_quote_lines_calc_text;
        input.ROC = result.ROC && result.ROC.tms_quote_lines_quote_amount;
        input.WG = result.WG && result.WG.tms_quote_lines_quote_amount;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/getQuoteToLastMile/quoteResultAnalyzer.ts